import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-sommario-urgenza-view',
  templateUrl: './form-sommario-urgenza-view.component.html',
  styleUrls: ['./form-sommario-urgenza-view.component.css']
})
export class FormSommarioUrgenzaViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
